import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=a291b8ac&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=a291b8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a291b8ac",
  null
  
)

export default component.exports